import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['%'] as const;

const validator = AbstractMeasurement.minMax
    .extend({
        unit: z.literal('%').default('%'),
    })
    .optional();

export const PowerTolerance = {
    validator,
    units,
};
